/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatListResponse } from '../../models/chat-list-response';

export interface GetChats$Params {
}

export function getChats(http: HttpClient, rootUrl: string, params?: GetChats$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatListResponse>> {
  const rb = new RequestBuilder(rootUrl, getChats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChatListResponse>;
    })
  );
}

getChats.PATH = '/api/chat/list';
